import React from 'react'
import { useTranslation } from 'react-i18next'
import Created from '../components/Created'
import Header from '../components/Header'
import Tecnologias from '../components/Tecnologias'




export default function TecnologiasPage () {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col bg-gray-600 text-white">
        < Header
          langSwitcher
          appsBackEnd={t('nav.projetos')}
          contatos={t('nav.contatos')}
          homePage={t('nav.homePage')}
        />
        <Tecnologias />
        <Created />
    </div>
  )
}
